<template>
  <div v-wechat-title="'收银台'" class="h-screen flex flex-col">
    <div class="flex items-center px-15 py-10">
      <div class="w-150 h-40 flex items-center justify-around border-1 border-[#CECECE] rounded-full">
        <i class="icon iconfont iconarrow-left-filling" @click="handleChangeDate('subtract')"></i>
        <span class="date_info" @click="handleChangeDate('select')">{{ date || "请选择" }}</span>
        <i class="icon iconfont iconarrow-right-filling" @click="handleChangeDate('add')"></i>
      </div>
      <van-search
          class="ml-10 flex-1 h-40 rounded-full"
          input-align="center"
          background="#F8F7FC"
          v-model="tempKeyword"
          placeholder="患者姓名或手机号"
          @search="handleSearch"
      />
    </div>

    <van-calendar
        v-model="showCalendar"
        :default-date="new Date(date)"
        :min-date="new Date(2020, 0, 1)"
        :show-confirm="false"
        @confirm="(date) => handleChangeDate('confirm', date)"
    />

    <van-tabs v-model="tabsData.activeName" @change="(name) => handleChangeTab(name)" class="flex-1 bg-[#F6F6F4]" color="#CF8C57" title-active-color="#CF8C57" swipeable>
      <van-tab class="h-[calc(100vh-106px)] overflow-y-auto" v-for="tab in tabsData.tabList" :key="tab.name" :title="tab.title" :name="tab.name" :badge="tab.badge" :ref="'tabPane-' + tab.name">
        <van-pull-refresh v-model="tabsData.refresh" @refresh="handleGetChargeData({ init: true })">
          <div class="min-h-[calc(100vh-106px)]">
            <div class="text-center py-60 text-[#898989] text-16" v-if="tab.noData">暂无数据</div>
            <van-list
                v-else
                :ref="'vanList'"
                :name="tab.name"
                v-model="tab.loading"
                :finished="tab.finished"
                @load="handleGetChargeData"
                :immediate-check="false"
                :offset="30"
                finished-text="加载完成"
            >
              <template #loading v-if="tabsData.refresh"><div></div></template>

              <div class="px-15 mb-15">
                <div class="mt-20 px-20 py-15 rounded-10 bg-gradient-1 bg-white" v-for="item in tab.list" :key="item.order_id">
                  <div class="flex items-center">
                    <div class="text-16 leading-22 font-bold">{{ item.customer_name }}</div>

                    <div class="pl-6 flex-shrink-0 ml-auto text-14 leading-20 text-[#9D9D9D]" @click="detail(item.order_id,tab.name)">
                      <span>订单详情</span>
                      <van-icon name="arrow" />
                    </div>
                  </div>

                  <div class="mt-8 text-[#9D9D9D] text-14 leading-20">
                    <span>{{ item.user_sex_name }}</span>
                    <span class="ml-4">{{ item.age }}</span>
                    <span class="ml-4">{{ item.user_phone }}</span>
                  </div>

                  <div class="mt-10 h-1 bg-[#D8D8D8]"></div>

                  <div class="mt-10 flex justify-between text-14 leading-20 flex items-center">
                    <div
                        class="flex-shrink-0 mr-4 px-2 py-1"
                        :style="{
                          backgroundColor: item.service_type === '1000' ? '#ef4444' : '#EAB03C',
                          color: '#ffffff',
                          padding: '4px 8px'
                        }"
                    >
                      {{ item.service_type_name }}
                    </div>
                    <div>{{ item.create_time }}</div>
                  </div>

                  <div class="mt-10 flex justify-between text-14 leading-20">
                    <div class="text-[#555555] flex-shrink-0 mr-4">就诊医生</div>
                    <div>{{ item.disp_name }}</div>
                  </div>
                  <div class="mt-10 flex justify-between text-14 leading-20"  v-if="tab.name == 0 || tab.name == 1 ||tab.name == 2">
                    <div class="text-[#555555] flex-shrink-0 mr-4">应收金额</div>
                    <div
                        :style="{ color: item.receivable_fee != null ? '#ef4444' : '#9D9D9D' }"
                    >
                      {{ item.receivable_fee != null ? `￥${item.receivable_fee}` : '--' }}
                    </div>
                  </div>

                  <div class="mt-10 flex justify-between text-14 leading-20" v-if="tab.name == 1 || tab.name == 2">
                    <div class="text-[#555555] flex-shrink-0 mr-4">实收金额</div>
                    <div
                        :style="{ color: item.act_fee != null ? '#ef4444' : '#9D9D9D' }"
                    >
                      {{ item.act_fee != null ? `￥${item.act_fee}` : '--' }}
                    </div>
                  </div>

                  <div class="mt-10 flex justify-between text-14 leading-20" v-if="tab.name == 2">
                    <div class="text-[#555555] flex-shrink-0 mr-4">欠费金额</div>
                    <div
                        :style="{ color: item.arrearage_fee != null ? '#ef4444' : '#9D9D9D' }"
                    >
                      {{ item.arrearage_fee != null ? `￥${item.arrearage_fee}` : '--' }}
                    </div>
                  </div>

                  <div class="mt-10 flex justify-between text-14 leading-20" v-if="tab.name == 3">
                    <div class="text-[#555555] flex-shrink-0 mr-4">应退金额</div>
                    <div
                        :style="{ color: item.receivable_fee != null ? '#ef4444' : '#9D9D9D' }"
                    >
                      {{ item.receivable_fee != null ? `￥${-item.receivable_fee}` : '--' }}
                    </div>
                  </div>

                  <div class="mt-10 flex justify-between text-14 leading-20" v-if="tab.name == 3">
                    <div class="text-[#555555] flex-shrink-0 mr-4">已退金额</div>
                    <div
                        :style="{ color: item.refund_fee != null ? '#ef4444' : '#9D9D9D' }"
                    >
                      {{ item.refund_fee != null ? `￥${item.refund_fee}` : '--' }}
                    </div>
                  </div>

                  <div class="mt-15 flex flex-wrap justify-end text-14 leading-20">
                    <div
                        v-if="(tab.name == 0 || tab.name == 2) && item.receivable_fee"
                        class="ml-12 h-35 leading-35 px-15 text-[#555555] rounded-full border-1 border-[#CECECE]"
                        @click="send(item.order_id)"
                    >
                      微信通知
                    </div>

                    <div
                        v-if="tab.name == 0"
                        class="ml-12 h-35 leading-35 px-15 text-white hover:text-white focus:text-white rounded-full bg-[#CF8C57]"
                        @click="finishOrder(item.order_id)"
                    >
                      结单
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  chargepage, chargestatistics, wxsendpaynotice, enddiagnosis
} from "@/api/medical";
import { mapGetters } from "vuex";
import { Toast } from "vant";

export default {
  name: "chargeWorkbench",
  components: {},
  data() {
    return {
      firstActivated: true,

      showCalendar: false,

      date: dayjs().format("YYYY-MM-DD"),
      keyword: "",
      tempKeyword: "",

      tabsData: {
        refresh: false,
        activeName: "0",
        tabList: [
          { title: "待收费", name: "0", loading: false, noData: false, finished: false, page: 1, list: [] },
          { title: "已收费", name: "1", loading: false, noData: false, finished: false, page: 1, list: [] },
          { title: "欠费管理", name: "2", loading: false, noData: false, finished: false, page: 1, list: [] },
          { title: "退款管理", name: "3", loading: false, noData: false, finished: false, page: 1, list: [] },
        ],
      },

      scrollTopMap: {},
    };
  },
  computed: {
    ...mapGetters(["username", "clinicid"]),
  },
  watch: {},
  methods: {
    /**
     * 搜索
     */
    handleSearch() {
      this.keyword = this.tempKeyword;
      this.handleGetChargeData({ init: true });
    },

    /**
     * 切换日期
     * 类型 select：选择、confirm：日历确定、add：下一日、subtract：上一日
     * @param type
     */
    handleChangeDate(type, date) {
      const oldDate = this.date;

      switch (type) {
        case "add":
          this.date = dayjs(this.date).add(1, "day").format("YYYY-MM-DD");
          break;

        case "subtract":
          this.date = dayjs(this.date).subtract(1, "day").format("YYYY-MM-DD");
          break;

        case "select":
          this.showCalendar = true;
          break;

        case "confirm":
          this.date = dayjs(date).format("YYYY-MM-DD");
          this.showCalendar = false;
          break;
      }

      if (oldDate != this.date) {
        this.handleGetChargeData({ init: true });
      }
    },

    /**
     * 切换tab
     */
    handleChangeTab(name) {
      this.tabsData.activeName = name;
      this.handleGetChargeData({ init: true });
    },

    /**
     * 获取收银台数据
     */
    async handleGetChargeData({ init } = {}) {
      const { tabList, activeName } = this.tabsData;

      if (init) {
        this.scrollTopMap = {}
        tabList.forEach((item) => {
          // if (item.name === '0' || item.name === '2') {
          //   item.badge = 0;
          // } else {
          //   item.badge = null; // 关键：不显示 badge
          // }
          item.badge = null;
          item.loading = item.name === activeName;
          item.noData = false;
          item.finished = false;
          item.page = 1;
          item.list = [];
        });

        this.getStatistics();
      }

      const data = tabList.find((item) => item.name === activeName);

      try {
        const { response_body: res } = await chargepage({
          qrydate: this.date,
          keyword: this.keyword,
          page: data.page,
          qrystatus: activeName,
          username: this.username,
          clinicid: this.clinicid,
        });

        this.tabsData.refresh = false;

        if (!Array.isArray(res.list) || res.list.length === 0) {
          data.noData = true;
          return;
        }

        data.list = data.list.concat(res.list);
        data.page++;
        data.loading = false;
        if (data.name === '0' || data.name === '2') {
          data.badge = res.count;
        }

        if (data.list.length >= res.count) {
          data.finished = true;
        }
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * 获取收银台统计数据
     */
    async getStatistics() {
      try {
        const { response_body: res } = await chargestatistics({
          qrydate: this.date,
          keyword: this.keyword,
          username: this.username,
          clinicid: this.clinicid,
        });

        const tabKeyData = {
          "0": "no_pay_num",
          "2": "refund_num",
        };

        this.tabsData.tabList.forEach((item) => {
          const key = tabKeyData[item.name];
          const num = Number(res[key] || 0);


          if (num > 0) {
            this.$set(item, 'badge', num);
          } else {
            this.$delete(item, 'badge');
          }
        });
      } catch (error) {
        console.error(error);
      }
    },

    //订单详情
    detail(orderid,status) {
      this.$store.dispatch('changeIsRefresh', '1')
      this.$router.push({ path: '/orderDetail', query: { orderid: orderid,status:status} })
    },

    //发送微信通知
    send(orderid) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否通知客户付款？付款通知将通过微信公众号下发模板消息，请提醒客户注意查收',
      }).then(() => {
        // 确认
        Toast({
          type: "loading",
          duration: 0,
        });
        let data = {
          orderid: orderid,
        };
        wxsendpaynotice(data).then(response => {
          if (Toast) {
            Toast.clear();
          }

          if(response.response_body.msg){
            Toast.success('推送成功');
          }else{
            Toast.fail(response.response_body.errorMsg);
          }
        });
      }).catch(() => {
        // 取消

      })

    },

    /**
     * 结单
     */
    finishOrder(orderid) {
      this.$dialog.confirm({
        title: '提示',
        message: '您确认将此订单进行结单操作吗？',
      }).then(() => {
        // 确认
        let data = {
          orderid: orderid,
          username: this.username,
        }
        enddiagnosis(data).then(response => {
          if(response.response_body.msg){
            Toast.success('结单成功');
          }else{
            Toast.fail(response.response_body.errorMsg);
          }
          this.handleGetChargeData({ init: true }) //刷新列表
        }).catch(() => {
          Toast.fail("结单操作失败，请稍后重试");
          this.handleGetChargeData({ init: true }) //刷新列表
        });
      }).catch(() => {
        // 取消
      })
    },

    saveScrollTop() {
      const active = this.tabsData.activeName;
      const tabRef = this.$refs[`tabPane-${active}`];

      if (tabRef && tabRef[0]) {
        this.scrollTopMap[active] = tabRef[0].$el.scrollTop;
      }
    },

    restoreScrollTop() {
      const active = this.tabsData.activeName;
      const tabRef = this.$refs[`tabPane-${active}`];

      const top = this.scrollTopMap[active];
      if (tabRef && tabRef[0] && typeof top === 'number') {
        tabRef[0].$el.scrollTop = top;
      }
    },

  },
  created() {
    console.log("进入create")
    this.$store.dispatch("hideOrShowNav", false);
    // this.handleGetChargeData({init: true});
  },
  activated() {
    // console.log("进入activated")
    if (this.firstActivated) {
      // console.log("进入firstActivated")

      this.tabsData.activeName = "0";
      this.handleGetChargeData({ init: true });
      // return;
    }else{
      this.restoreScrollTop();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path != '/'){
      this.firstActivated = false;
      this.saveScrollTop();
    }else{
      this.firstActivated = true;
    }

    next();
  },
};
</script>
<style lang="scss" scoped>
.bg-gradient-1 {
  background-image: linear-gradient(to bottom, rgba(207, 140, 87, 0.2), transparent 75px);
}
</style>
